<template>
  <div class="top-bar-Section">
    <v-list class="list-actions-user" style="z-index: 10;">
      <v-list-group value="Productos">
        <template v-slot:activator="{ props }">
          <v-list-item
            v-bind="props"
            prepend-icon="mdi-account-circle"
            :title=" user?.name  "/>
        </template>
        <v-divider></v-divider>
        <!--
        <v-list-item prepend-icon="mdi-square-edit-outline"
          style="padding-left: 5px !important; "
          title="Editar negocio" link />
        -->
        <v-list-item prepend-icon="mdi-help-circle-outline"
          style="padding-left: 5px !important; "
          title="Ayuda" link
          to="/help" />
        <v-list-item prepend-icon="mdi-book-open-blank-variant-outline"
          style="padding-left: 5px !important;"
          title="Términos de uso"
           href="https://commercia.app/terminos_uso_app"
          target="_blank"
          rel="noopener" />
        <v-list-item prepend-icon="mdi-shield-check-outline"
          style="padding-left: 5px !important;"
          title="Política de privacidad"
          href="https://commercia.app/privacidad_app"
          target="_blank"
          rel="noopener" />
        <v-divider></v-divider>
        <v-list-item prepend-icon="mdi-login-variant"
          style="padding-left: 5px !important;"
           @click="logout"
          title="Cerrar sesión" link />
      </v-list-group>
    </v-list>
  </div>
</template>
<script>
export default {
  name: 'CommerciaVueTopBar',
  data () {
    return {
    }
  },
  computed: {
    user () {
      return this.$store.getters.user
    }
  },
  methods: {
    logout () {
      this.$store.dispatch('logout')
    }
  }
}
</script>
<style scoped>
.top-bar-Section{
  width: 100%;
  background-color: #FFFFFF;
  height: 50px;
  box-shadow: 0px -2px 5px rgba(0, 0, 0, 0.6);
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-items: center;

}
.list-actions-user{
  position: absolute;
  top: 0;
  right: 0;
  padding: 0;
}
</style>
